import React from "react";
import { Link } from "react-router-dom";
import { useFontSize } from "../../../FontSizeContext";
import naaclogo from "../../../assets/img/logo/naac-logo.png";

const TopHeader = (props) => {
  const { fontSize, increaseFontSize, decreaseFontSize, resetFontSize } =
    useFontSize();
  const { topBarClass, emailAddress, phoneNumber, Location } = props;

  const date = () => {
    return new Date().toLocaleString("en-IN", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
  return (
    <div className={topBarClass ? topBarClass : "topbar-area hidden-md"}>
      <style>
        {`
            body{
              font-size: ${fontSize}px;
            }
           .full-width-header .rs-header .topbar-area .topbar-contact li div.naac-accreditation > strong {
              font-size: calc(${fontSize}px - 4px);
            }
            .full-width-header .rs-header .topbar-area .topbar-contact li div.naac-accreditation .naac-accreditation-content p{
              font-size: calc(${fontSize}px - 2px);
            }
            .full-width-header .rs-header .topbar-area .topbar-right li.login-register a, 
            .readon.orange-btn, 
            .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a, 
            .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a, 
            table th, table td,
            .search-modal .search-block .search-results-lists ul li a .result-description  {
              font-size: calc(${fontSize}px - 2px);
            }
            .breadcrumb-bg .breadcrumbs-text ul li{
              font-size: calc(${fontSize}px + 2px);
            }
            .content-wrapper .content-section h3,
            .content-wrapper h2, h4{
              font-size: calc(${fontSize}px + 10px);
            }
            .rs-footer .footer-top-social .social_msg{
              font-size: calc(${fontSize}px + 18px);
            }
            .rs-footer .footer-center h3{
                font-size: calc(${fontSize}px + 12px);
            }
            .rs-footer.home9-style .footer-top .widget-title,
            .content-wrapper .content-section h4{
                font-size: calc(${fontSize}px + 4px);
            }
            .rs-footer .footer-center h4{
                font-size: calc(${fontSize}px + 6px);
            }
            .rs-about.style1 .info-part h2{
              font-size: calc(${fontSize}px + 4px);
            }
            .sec-title .sub-title{
              font-size: calc(${fontSize}px + 16px);
            }
            h3{
              font-size: calc(${fontSize}px + 12px);
            }
            .rs-slider.main-home .fixedBannerTitle .content-part .sl-title,
            .rs-slider.main-home .fixedBannerTitle .content-part .sl-sub-title{
              font-size: calc(${fontSize}px + 28px);
            }

            @media only screen and (max-width: 480px){
              .rs-slider.main-home .fixedBannerTitle .content-part .sl-title,
              .rs-slider.main-home .fixedBannerTitle .content-part .sl-sub-title{
                font-size: calc(${fontSize}px + 16px);
              }
            }
        `}
      </style>
      <div className="container-fluid">
        <div className="row y-middle">
          <div className="col-md-4">
            <ul className="topbar-contact">
              <li>
                <span>{date()}</span>
              </li>
              <li>
                <div className="d-flex align-items-center naac-accreditation">
                  <strong className="position-relative">
                    Accredited 'A+' Grade by NAAC
                  </strong>
                  <div className="naac-accreditation-content">
                    <img src={naaclogo} title="NAAC Logo" alt="NAAC Logo" />
                    <p>
                      <strong>
                        JNTUK (Jawaharlal Nehru Technological University,
                        Kakinada)
                      </strong>{" "}
                      has achieved a remarkable milestone by securing an{" "}
                      <b>'A+'</b> grade from{" "}
                      <strong>
                        NAAC (National Assessment and Accreditation Council)
                      </strong>{" "}
                      at the national level. This prestigious accreditation
                      underscores JNTUK's commitment to academic excellence,
                      research, and overall institutional quality. The 'A+'
                      grade is a testament to the university's unwavering
                      dedication to providing high-quality education and
                      fostering a conducive environment for innovation and
                      learning. This achievement not only reflects JNTUK's
                      standing as a premier institution but also reinforces its
                      role in shaping future leaders and contributing
                      significantly to the advancement of education on a
                      national scale.
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className="col nav-bar-top">
            <ul className="topbar-right">
              <li className="login-register">
                <Link
                  to={{
                    pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Notifications`,
                  }}
                  target="_blank"
                >
                  NOTIFICATION CENTER
                </Link>
              </li>
              <li className="login-register">
                <Link
                  to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}#` }}
                  target="_blank"
                >
                  ALUMNI
                </Link>
              </li>
              <li className="login-register">
                <Link
                  to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}#` }}
                  target="_blank"
                >
                  STUDENT CORNER
                </Link>
              </li>
              <li className="login-register">
                <Link
                  to={{
                    pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/gallery`,
                  }}
                  target="_blank"
                >
                  NEWS & EVENTS
                </Link>
              </li>
              <li className="login-register">
                <a
                  href="https://jntuk.edu.in/wp-content/uploads/2024/02/Administration.pdf"
                  target="_blank"
                >
                  DIRECTORY
                </a>
              </li>
              <li className="login-register">
                <a
                  href="https://mail.google.com/a/jntuk.edu.in"
                  target="_blank"
                >
                  JNTUK EMAIL
                </a>
              </li>
            </ul>
            <button onClick={decreaseFontSize}>A-</button>
            <button onClick={resetFontSize}>A</button>
            <button onClick={increaseFontSize}>A+</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
